import { GlobalContext } from 'app/store/globalcontext';
import React, { useContext } from 'react';
import TelaBloqueio from '../../components/TelaBloqueio';
import { ValidacaoClienteModais } from '../../ValidacaoClienteModais';

const ModalPeriodoTrial = () => {
  const [modalValidacaoCliente] = useContext(GlobalContext).modalValidacaoCliente;

  return (
    <TelaBloqueio
      open={modalValidacaoCliente === ValidacaoClienteModais.modalPeriodoTrial}
      mensagem={
        <>
          O período de gratuidade para teste expirou. <br />
          Entre em contato com o setor de atendimento para garantir acesso ao seu novo sistema financeiro.
        </>
      }
    />
  );
};

export default ModalPeriodoTrial;
